import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import { SharedUiAlertModule } from '@snelstart/ui-alert';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-aanvrager',
  standalone: true,
    imports: [CommonModule, SharedUiAlertModule],
  templateUrl: './tekst-aanvrager.component.html',
  styleUrl: './tekst-aanvrager.component.scss',
})
export class TekstAanvragerComponent {}

